import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import SwitchUI from '../../../widgets/action/SwitchUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LinkWithSpinnerUI from '../../../widgets/action/LinkWithSpinnerUI'
import ChatMessageReplyModalSF from './ChatMessageReplyModalSF'
import FileUploadModalSF from '../../../widgets/form/FileUploadModalSF'
import ChatMessageStatusModalSF from './ChatMessageStatusModalSF'
import ChatMessageSetFollowUpModalSF from './ChatMessageSetFollowUpModalSF'
import './ChatMessageList.css'

const ChatMessageListUI = ({ context, account, onRefreshClick, userMessageList,
  checked, onShowStarred,
  onReplyClick, onReplyCancel, replyMode, selectedUserId, selectedAccountId, selectedPhone,
  onDownloadClick, downloadMode, selectedMesgDate,
  fileUploadMode, onFileUploadClick, onfileUploadCancel, onfileUpload,
  statusUpdateMode, onUpdateStatusClick, onUpdateStatusCancel,
  setFollowUpMode, onSetFollowUpClick, onSetFollowUpCancel
}) =>
  <div className='c_chat'>
    <LRTableActionsUI location='top'
      left={
        <div className='g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          {/*
            context.permissions.includes('su_manage') &&
            <IconButtonUI messageList={messageList} icon='icon-pencil' onClick={onWriteClick} label='Write Message' />
          */}
          <span className='g_m_left_100 g_large'><b>WhatsApp Messages</b></span>
        </div>
      }
      right={
        <span className='g_flex_h g_flex_right'>
          <span className='g_muted g_m_right_50'>
            Starred
          </span>
          <SwitchUI
            checked={checked}
            onChange={onShowStarred}
          />
        </span>
      }
    />

    {
      userMessageList && userMessageList.map((chats, i) =>
        <CardUI key={i} className='g_m_bottom_100'
          title={
            <div className='g_flex_h'>
              <span className='user_name'>
                <span>{chats.addressableName}</span>
                <span className='g_m_left_50'>{chats.phoneNumber}</span>
              </span>
              <Link to={`/su/accounts/${chats.accountId}/chat`} className='acc_name'>{chats.accountName}</Link>
            </div>
          }
        >
          {
            !checked && chats.chatMessageList.map((message, j) =>
              <span className={`g_flex_h ${message.csr ? 'g_flex_right' : 'g_flex_left'}`} key={j}>
                <ChatListUI context={context} message={message} onReplyClick={onReplyClick} onFileUploadClick={onFileUploadClick}
                  onDownloadClick={onDownloadClick} downloadMode={downloadMode} selectedMesgDate={selectedMesgDate}
                  onUpdateStatusClick={onUpdateStatusClick} onSetFollowUpClick={onSetFollowUpClick} />
              </span>
            )
          }
          {
            checked && chats.chatMessageList.filter(f => f.followUp).map((message, j) =>
              <span className={`g_flex_h ${message.csr ? 'g_flex_right' : 'g_flex_left'}`} key={j}>
                <ChatListUI context={context} message={message} onReplyClick={onReplyClick} onFileUploadClick={onFileUploadClick}
                  onDownloadClick={onDownloadClick} downloadMode={downloadMode} selectedMesgDate={selectedMesgDate}
                  onUpdateStatusClick={onUpdateStatusClick} onSetFollowUpClick={onSetFollowUpClick} />
              </span>
            )
          }
        </CardUI>
      )
    }

    <ChatMessageReplyModalSF context={context} account={account}
      replyMode={replyMode} selectedUserId={selectedUserId} selectedAccountId={selectedAccountId}
      selectedPhone={selectedPhone}
      onCancelClick={onReplyCancel} onRefreshClick={onRefreshClick}
    />
    <ChatMessageStatusModalSF context={context} updateMode={statusUpdateMode}
      selectedAccountId={selectedAccountId} selectedMesgDate={selectedMesgDate}
      selectedPhone={selectedPhone}
      onCancelClick={onUpdateStatusCancel} onRefreshClick={onRefreshClick}
    />
    <ChatMessageSetFollowUpModalSF context={context} updateMode={setFollowUpMode}
      selectedAccountId={selectedAccountId} selectedMesgDate={selectedMesgDate}
      selectedPhone={selectedPhone}
      onCancelClick={onSetFollowUpCancel} onRefreshClick={onRefreshClick}
    />
    <FileUploadModalSF
      context={context}
      uploadMode={fileUploadMode}
      onCancelClick={onfileUploadCancel}
      signedUrlApi={`/api/su/accounts/${selectedAccountId}/files/fileUploadSignedUrl`}
      onUpload={onfileUpload}
      multiple={true}
    />
  </div>

const ChatListUI = ({ context, message, onReplyClick, onDownloadClick, downloadMode, selectedMesgDate,
  onFileUploadClick, onUpdateStatusClick, onSetFollowUpClick }) =>
  <div className='chat_sec csr g_m_bottom_50'>
    <div className='g_flex_v g_m_left_50 g_m_right_50 g_m_top_25 g_m_bottom_25'>
      <span>{message.message}
        {
          message.fileList && message.fileList.map((file, i) =>
            <span className='g_flex_h g_flex_left' key={i}>
              <LinkWithSpinnerUI
                onClick={onDownloadClick} dataAccId={message.accountId ? message.accountId : message.phoneNumber}
                rowId={message.messageDate + ':' + file.fileId + ':' + file.fileName}
                busy={downloadMode && selectedMesgDate == message.messageDate} label={file.fileName}
              />
              <span className='g_m_left_50 g_muted'>{file.sizeF}</span>
            </span>
          )
        }
      </span>
      <div className='g_flex_h g_m_top_25'>
        <span className='g_small g_muted'>{message.messageDateTimeF}</span>
        <span className='g_flex_h g_flex_right'>
          {
            !message.csr &&
            <>
              {
                context.permissions.includes('su_manage') &&
                <span className='g_m_left_100 icon icon-reply g_muted' onClick={onReplyClick}
                  data-id={message.userId} data-acc-id={message.accountId} data-phone={message.phoneNumber} />
              }
              {
                message.accountId &&
                <span className='g_m_left_50 icon icon-paperclip' onClick={onFileUploadClick}
                  data-id={message.userId} data-acc-id={message.accountId} />
              }
            </>
          }
          <span className='g_m_left_50 icon icon-archive g_muted' onClick={onUpdateStatusClick}
            data-acc-id={message.accountId} data-date={message.messageDate} data-phone={message.phoneNumber} />
          <span className={`g_m_left_50 ${message.followUp ? 'icon icon-star' : 'icon icon-star-o'}`} onClick={onSetFollowUpClick}
            data-acc-id={message.accountId} data-date={message.messageDate} data-phone={message.phoneNumber} />
        </span>
      </div>
    </div>
  </div>

export default ChatMessageListUI
